
















































































import { Component, Prop, Mixins } from 'vue-property-decorator';
import { BForm, BFormGroup, BFormInput, BFormCheckbox, BContainer, BButton, BRow, BCol, BIconCloudUpload, BIconTrash, BFormTextarea, BFormInvalidFeedback, BOverlay, BTabs, BTab, BFormSelect, BFormSelectOption, BIconPlus, BCard, BCardBody } from 'bootstrap-vue';
import Configuration from '@/types/Configuration';
import Validator, { handleValidationErrors } from '@/types/Validator';
import EntityReference from '@/types/EntityReference';
import UserProjectList from '@/components/UserProjectList.vue';
import ToasterMixin from '@/mixins/ToasterMixin';
import AxiosService from '@/services/axiosService';
import i18n from '../i18n';

const IdentityProviders = {
    AzureADBearer: 'AzureADBearer'
}

@Component({
    components: {
        'b-overlay': BOverlay,
        'b-tabs': BTabs,
        'b-tab': BTab,
        'b-container': BContainer,
        'b-card': BCard,
        'b-card-body': BCardBody,
        'b-row': BRow,
        'b-col': BCol,
        'b-form': BForm,
        'b-form-group': BFormGroup,
        'b-form-input': BFormInput,
        'b-form-invalid-feedback': BFormInvalidFeedback,
        'b-form-textarea': BFormTextarea,
        'b-form-checkbox': BFormCheckbox,
        'b-form-select': BFormSelect,
        'b-form-select-option': BFormSelectOption,
        'b-btn': BButton,
        'b-icon-cloud-upload': BIconCloudUpload,
        'b-icon-trash': BIconTrash,
        'icon-plus': BIconPlus,
        'user-project-list': UserProjectList
    }
})
export default class UserDetails extends Mixins(ToasterMixin) {
    @Prop() userId!: string

    isBusy = true;

    azureADBearerStatus = false;
    azureADBearerUsername = '';

    apiAccessToken = this.$store.state.apiAccessToken
    user: UserData = {
        id: '',
        sequenceId: 0,
        name: '',
        email: '',
        projects: [],
        identityProviders: [],
        isActive: true,
        isAdministrator: false
    }
    roles: EntityReference[] = [];
    projectsLookup: EntityReference[] = [];
    project: EntityReference = {
        id: '',
        name: ''
    };

    nameValidator: Validator = {
        isValid: null,
        errors: []
    }

    emailValidator: Validator = {
        isValid: null,
        errors: []
    }

    azureUsernameValidator: Validator = {
        isValid: null,
        errors: []
    }

    mounted() {
        this.apiAccessToken = this.$store.state.apiAccessToken;
        this.loadProjects();
        this.loadRoles();
        this.loadUser(this.userId);
    }

    clearValidators() {
        this.nameValidator = {
            isValid: null,
            errors: []
        }

        this.emailValidator = {
            isValid: null,
            errors: []
        }

        this.azureUsernameValidator = {
            isValid: null,
            errors: []
        }
    }

    async loadProjects() {
        try {
            const response = await AxiosService.request<EntityList>({
                url: `projectslookup`,
                method: 'GET'
            });

            this.projectsLookup = response.data.records ?? [];
        }
        catch (error) {
            if (error.response) {
                switch (error.response.status) {
                    case 404:
                        return this.$router.push(`/${i18n.locale}/notfound`);
                    case 403:
                        return this.$router.push(`/${i18n.locale}/accessdenied`);
                    default:
                        return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                }
            }
        }
    }

    async loadRoles() {
        try {
            const response = await AxiosService.request<EntityList>({
                url: `roleslookup`,
                method: 'GET'
            });

            this.roles = response.data.records ?? [];
        }
        catch (error) {
            if (error.response) {
                switch (error.response.status) {
                    case 404:
                        return this.$router.push(`/${i18n.locale}/notfound`);
                    case 403:
                        return this.$router.push(`/${i18n.locale}/accessdenied`);
                    default:
                        return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                }
            }
        }
    }

    async loadUser(userId: string) {
        if (userId.length == 0) {
            this.isBusy = false;
            return;
        }

        this.isBusy = true;

        try {
            const response = await AxiosService.request<UserData>({
                url: `usersadministration/${userId}`,
                method: 'GET'
            });

            this.user = response.data;
            if (this.user && this.user.identityProviders) {
                const azureADAuthSchemeIp = this.user.identityProviders.find(ip => ip.name === IdentityProviders.AzureADBearer);

                if (azureADAuthSchemeIp) {
                    this.azureADBearerUsername = azureADAuthSchemeIp.username;
                    this.azureADBearerStatus = azureADAuthSchemeIp.enabled;
                }
            }
        }
        catch (error) {
            if (error.response) {
                switch (error.response.status) {
                    case 404:
                        return this.$router.push(`/${i18n.locale}/notfound`);
                    case 403:
                        return this.$router.push(`/${i18n.locale}/accessdenied`);
                    default:
                        return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                }
            }
        }
        finally {
            this.isBusy = false;
        }
    }

    async onSubmit(e: Event) { // eslint-disable-line @typescript-eslint/no-unused-vars
        this.isBusy = true;

        this.clearValidators();

        const userToSave = this.mapSaveData(this.user);

        try {
            await AxiosService.request<boolean>({
                url: `usersadministration`,
                method: 'POST',
                data: userToSave
            });

            this.showToaster(this.$t('toaster.userSaved') as string, this.$t('toaster.saveUserTitle') as string, Configuration.ToasterVariantSuccess);
            this.$emit('user-saved', true);
        }
        catch (error) {
            if (error.response) {
                switch (error.response.status) {
                    case 404:
                        return this.$router.push(`/${i18n.locale}/notfound`);
                    case 403:
                        return this.$router.push(`/${i18n.locale}/accessdenied`);
                    case 400:
                        handleValidationErrors(this, error.response.data.errors.Name, this.nameValidator);
                        handleValidationErrors(this, error.response.data.errors.Email, this.emailValidator);
                        handleValidationErrors(this, error.response.data.errors.AzureUsername, this.azureUsernameValidator);

                        const unasignedErrors = error.response.data.errors[''];     // eslint-disable-line no-case-declarations
                        if (unasignedErrors && unasignedErrors.length > 0) {
                            for (let i = 0; i < unasignedErrors.length; i++) {
                                this.showToaster(this.$t(unasignedErrors[i]) as string, this.$t('toaster.errorTitle') as string, Configuration.ToasterVariantError);
                            }
                        }
                        return;
                    default:
                        return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                }
            }
        }
        finally {
            this.isBusy = false;
        }
    }

    async deleteUser() {
        try {
            const response = await AxiosService.request({
                url: `usersadministration/candelete/${this.userId}`,
                method: 'GET'
            });

            const canDelete = response.data.canDelete;

            if (!canDelete) {
                this.$bvModal.msgBoxOk(
                    this.$t('modal.deniedUserDeleteMessage', { userName: this.user.name }) as string, {
                        title: this.$t('modal.deniedUserDeleteTitle') as string,
                        centered: true,
                        buttonSize: 'sm',
                        okTitle: this.$t('modal.closeModal') as string
                    }
                );
                return;
            }

            this.$bvModal.msgBoxConfirm(this.$t('modal.confirmUserDeleteMessage', { userName: this.user.name }) as string, {
                title: this.$t('modal.confirmUserDeleteTitle') as string,
                    centered: true,
                    buttonSize: 'sm',
                    okTitle: this.$t('modal.confirmOkTitle') as string,
                    cancelTitle: this.$t('modal.confirmCancelTitle') as string
                })
                .then(value => {
                    if (value) {
                        this.isBusy = true;

                        try {
                            AxiosService.request<boolean>({
                                url: `usersadministration?id=${this.userId}`,
                                method: 'DELETE'
                            });

                            this.$root.$bvToast.toast(this.$t('toaster.userDeleted', { userName: this.user.name }) as string, {
                                title: this.$t('toaster.deleteUserTitle') as string,
                                autoHideDelay: Configuration.ToasterAutoHideDelay,
                                appendToast: true,
                                variant: Configuration.ToasterVariantSuccess,
                                toaster: Configuration.ToasterPosition
                            });
                            this.$emit('user-deleted', true);
                        }
                        catch (error) {
                            if (error.response) {
                                switch (error.response.status) {
                                    case 404:
                                        return this.$router.push(`/${i18n.locale}/notfound`);
                                    case 403:
                                        return this.$router.push(`/${i18n.locale}/accessdenied`);
                                    default:
                                        return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                                }
                            }
                        }
                        finally {
                            this.isBusy = false;
                        }
                    }
                })
                .catch(error => {
                    console.error(error);
                });
        }
        catch (error) {
            if (error.response) {
                switch (error.response.status) {
                    case 404:
                        return this.$router.push(`/${i18n.locale}/notfound`);
                    case 403:
                        return this.$router.push(`/${i18n.locale}/accessdenied`);
                    default:
                        return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                }
            }
        }
        finally {
            this.isBusy = false;
        }
    }

    addProject() {
        const prj = this.user.projects.filter(p => { return p.id == this.project.id });

        if (prj && prj.length > 0) {
            this.showToaster(this.$t('toaster.addProjectWarningProjectExists') as string, this.$t('toaster.addProjectWarningTitle') as string, Configuration.ToasterVariantWarning);
        }
        else {

            this.user.projects.push({
                id: this.project.id,
                name: this.project.name,
                roles: [],
                tasks: [],
                selectedRoles: []
            })
        }
    }

    onUserProjectChanged(projects: UserProject[]) {
        this.user.projects = projects;
    }

    mapSaveData(user: UserData): UserDataToSave {
        const userToSave: UserDataToSave = {
            id: user.id,
            sequenceId: user.sequenceId,
            name: user.name,
            email: user.email,
            isActive: user.isActive,
            isAdministrator: user.isAdministrator,
            projects: [],
            identityProviders: user.identityProviders
        };

        const ipAzureADBearer = userToSave.identityProviders.find(ip => ip.name === IdentityProviders.AzureADBearer);
        if (ipAzureADBearer) {
            ipAzureADBearer.username = this.azureADBearerUsername;
        }

        user.projects.forEach((p) => {
            const projectToSave: UserProjectToSave = {
                id: p.id,
                roles: p.roles.map(r => r.id),
                tasks: p.tasks.map(t => t.id)
            };

            userToSave.projects.push(projectToSave);
        })

        return userToSave;
    }

    toggleAzureADBearer() {
        let identityProvider = this.user.identityProviders.find(ip => { return ip.name === IdentityProviders.AzureADBearer });

        this.$nextTick(() => {
            if (identityProvider) {
                identityProvider.enabled = this.azureADBearerStatus;
            }
            else {
                identityProvider = {
                    name: IdentityProviders.AzureADBearer,
                    username: this.azureADBearerUsername,
                    enabled: this.azureADBearerStatus,
                    settings: null
                }

                this.user.identityProviders.push(identityProvider);
            }
        });
    }
}

interface UserData {
    id: string;
    sequenceId: number;
    name: string;
    email: string;
    projects: UserProject[];
    identityProviders: IdentityProvider[];
    isAdministrator: boolean;
    isActive: boolean;
}

interface UserDataToSave {
    id: string;
    sequenceId: number;
    name: string;
    email: string;
    projects: UserProjectToSave[];
    identityProviders: IdentityProvider[];
    isAdministrator: boolean;
    isActive: boolean;
}

interface UserProject extends EntityReference {
    roles: EntityReference[];
    tasks: EntityReference[];
    selectedRoles: (string | null)[];
}

interface UserProjectToSave {
    id: string | null;
    roles: (string | null)[];
    tasks: (string | null)[];
}

interface IdentityProvider {
    name: string;
    username: string;
    enabled: boolean;
    // eslint-disable-next-line
    settings: any;
}

interface EntityList {
    records: EntityReference[];
}
